var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_803_12009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3331 11.9551C23.3331 5.54019 18.1327 0.339844 11.7178 0.339844C5.30289 0.339844 0.102539 5.54019 0.102539 11.9551C0.102539 17.7531 4.35033 22.5585 9.90304 23.4297V15.3123H6.95373V11.9551H9.90304V9.3956C9.90304 6.485 11.6378 4.87676 14.2902 4.87676C15.5616 4.87676 16.8911 5.10392 16.8911 5.10392V7.96289H15.4261C13.983 7.96289 13.5326 8.85865 13.5326 9.77636V11.9551H16.7542L16.2392 15.3123H13.5326V23.4297C19.0853 22.5585 23.3331 17.7531 23.3331 11.9551Z",
    fill: "currentColor",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_803_12009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.2331,
    height: 23.2331,
    fill: "currentColor",
    transform: "translate(0.0986328 0.339844)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.de268354256011ade8dec6b5ef0a3cfb.svg";
export { ForwardRef as ReactComponent };